// Analytics hooks only — no provider wired yet.
// Events queue on window.sayitEvents so any provider can be attached later.
export const EVENTS = {
  HERO_CTA: "hero_cta_click",
  DEMO_TONE: "demo_tone_click",
  PRICING_CTA: "pricing_cta_click",
  CHECKOUT_STARTED: "checkout_started",
};

export function track(event, payload = {}) {
  const entry = { event, ...payload, ts: new Date().toISOString() };
  if (typeof window !== "undefined") {
    window.sayitEvents = window.sayitEvents || [];
    window.sayitEvents.push(entry);
  }
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("[sayit:analytics]", entry);
  }
}
